import { request } from '../api';

export const getCheckSheetTasks = (action) => {
  const payload: any = {
    url: `/check-sheets/tasks/${action.checkSheetType}`,
    options: {
      method: 'GET'
    }
  };

  return request(action, { payload });
};

export const saveCheckSheet = (action) => {
  const payload: any = {
    url: `/check-sheets/report`,
    options: {
      method: 'POST',
      data: action.data
    }
  };

  return request(action, { payload });
};

export const updateCheckSheet = (action) => {
  const payload: any = {
    url: `/check-sheets/report`,
    options: {
      method: 'PATCH',
      data: action.data
    }
  };

  return request(action, { payload });
};

export const fetchCheckSheet = (action) => {
  const payload: any = {
    url: `/check-sheets/report/${action.checkSheetId}`,
    options: {
      method: 'GET'
    }
  };

  return request(action, { payload });
};

export const downloadCommissioningPdf = (action) => {
  const payload: any = {
    url: `/check-sheets/commissioning-pdf/${action.reportId}`,
    options: {
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Accept': 'application/pdf',
      }
    }
  };

  return request(action, { payload });
};

export const downloadCommissioningSummaryPdf = (action) => {
  const payload: any = {
    url: '/check-sheets/commissioning-summary-pdf',
    query: action.params,
    options: {
      method: 'GET',
      responseType: 'blob',
      headers: { 'Accept': 'application/pdf' },
    }
  };
  return request(action, { payload });
};

export const downloadBulkCommissioningPdf = (action) => {
  const payload: any = {
    url: '/check-sheets/commissioning-pdf/bulk',
    options: {
      method: 'POST',
      responseType: 'blob',
      headers: {
        'Accept': 'application/pdf',
      },
      data: { ids: action.reportIds },
    }
  };

  return request(action, { payload });
};

export const fetchDeviceCheckSheets = (action) => {
  const paginationDetails = action.paginationDetails;
  const {
    page,
    pageSize,
    sort
  } = paginationDetails;
  const query: any = {};
  if (page !== null && pageSize !== null) {
    query.page = page;
    query.pageSize = pageSize;
  }

  if (sort) {
    query.order = sort;
  }

  const payload: any = {
    url: `/check-sheets/reports/${action.checkSheetType}/${action.deviceId}`,
    query,
    options: {
      method: 'GET'
    }
  };

  return request(action, { payload });
};

export const fetchCommissioningReports = (action) => {
  const paginationDetails = action.paginationDetails;
  const { page, pageSize, sort, type, status, unlinkedOnly, unit, system, commodity, location, priority, controllerId, deadleg, deviceGroup } = paginationDetails;
  const query: any = {};
  if (page !== null && pageSize !== null) {
    query.page = page;
    query.pageSize = pageSize;
  }
  if (sort) {
    query.order = sort;
  }
  if (type) {
    query.type = type;
  }
  if (status) {
    query.status = status;
  }
  if (unlinkedOnly) {
    query.unlinkedOnly = 'true';
  }
  if (unit) {
    query.unit = unit;
  }
  if (system) {
    query.system = system;
  }
  if (commodity) {
    query.commodity = commodity;
  }
  if (location) {
    query.location = location;
  }
  if (priority) {
    query.priority = priority;
  }
  if (controllerId) {
    query.controllerId = controllerId;
  }
  if (deadleg) {
    query.deadleg = deadleg;
  }
  if (deviceGroup) {
    query.deviceGroup = deviceGroup;
  }

  const payload: any = {
    url: '/check-sheets/commissioning',
    query,
    options: {
      method: 'GET'
    }
  };

  return request(action, { payload });
};

export const linkDeviceToCheckSheet = (action) => {
  const payload: any = {
    url: `/check-sheets/commissioning/${action.reportId}/link-device`,
    options: {
      method: 'PUT',
      data: { deviceId: action.deviceId }
    }
  };

  return request(action, { payload });
};

export const updateDeviceLink = (action) => {
  const payload: any = {
    url: `/check-sheets/commissioning/${action.reportId}/update-device-link`,
    options: {
      method: 'PUT',
      data: { deviceId: action.deviceId, checkSheetType: action.checkSheetType }
    }
  };

  return request(action, { payload });
};

export const fetchReportsCsvExport = (action) => {
  const query: any = {};
  const selected = action.selectedFilters ? action.selectedFilters.toJS() : {};
  const optional = action.optionalFilters ? action.optionalFilters.toJS() : {};

  Object.entries({ ...selected, ...optional }).forEach(([key, val]) => {
    if (val === null || val === undefined || val === '') return;
    query[key] = typeof val === 'boolean' ? String(val) : val;
  });

  const payload: any = {
    url: '/check-sheets/csv_report/',
    query,
    options: {
      method: 'GET',
      responseType: 'blob',
      headers: {
        Accept: 'text/csv'
      }
    }
  };

  return request(action, { payload });
};
